<template>
  <div class="settings-container dark-theme">
    <!-- 页面头部 -->
    <div class="settings-header">
      <h1 class="settings-title">{{ translate('users.header.title19') }}</h1>
      <p class="settings-subtitle">{{ languageState.languageCode === 'zh' ? '管理您的账户安全设置' : 'Manage your account security settings' }}</p>
    </div>

    <!-- 标签页布局 -->
    <a-tabs v-model="activeKey" :animated="false" class="settings-tabs">
      <!-- 密码修改 -->
      <a-tab-pane :tab="translate('users.header.title1')" key="password">
        <div class="settings-card">
          <div class="card-content">
            <a-form
              :form="form"
              layout="vertical"
              class="password-form"
            >
              <div class="form-row">
                <a-form-item
                  :label="translate('users.header.title2')"
                  name="oldpasswd"
                  :rules="[{ required: true, message: translate('users.header.title2') + '必填' }]"
                  class="form-item"
                >
                  <a-input-password v-model="formData.oldpasswd" :placeholder="translate('users.header.title6')" class="custom-input" />
                </a-form-item>
              </div>
              <div class="form-row">
                <a-form-item
                  :label="translate('users.header.title3')"
                  name="newpasswd"
                  :rules="[{ required: true, message: translate('users.header.title3') + '必填' }]"
                  class="form-item"
                >
                  <a-input-password v-model="formData.newpasswd" :placeholder="translate('users.header.title7')" class="custom-input" />
                </a-form-item>
              </div>
              <div class="form-row">
                <a-form-item
                  :label="translate('users.header.title4')"
                  name="passwordcheck"
                  :rules="[{ required: true, message: translate('users.header.title4') + '必填' }, { validator: this.rePassword, message: this.languageState.languageCode === 'zh' ? '两次密码不一致' : 'Two passwords do not match' }]"
                  class="form-item"
                >
                  <a-input-password v-model="formData.passwordcheck" :placeholder="translate('users.header.title8')" class="custom-input" />
                </a-form-item>
              </div>
              <div class="form-actions">
                <a-button type="primary" @click="onSubmit" :loading="submitting" class="submit-btn">
                  <a-icon type="save" />
                  {{ translate('users.header.title1') }}
                </a-button>
                <a-button @click="onReset" class="reset-btn">
                  <a-icon type="reload" />
                  {{ translate('users.header.title5') }}
                </a-button>
              </div>
            </a-form>
          </div>
        </div>
      </a-tab-pane>

      <!-- 谷歌验证 -->
      <a-tab-pane :tab="translate('users.header.title20')" key="google-auth">
        <div class="settings-card">
          <div class="card-content">
            <div class="setting-item">
              <div class="setting-info">
                <div class="setting-icon-wrapper google-icon">
                  <a-icon type="safety-certificate" />
                </div>
                <div class="setting-text">
                  <div class="setting-title">{{ translate('users.header.title20') }}</div>
                  <div class="setting-desc">{{ translate('users.header.title29') }}</div>
                </div>
              </div>
              <div class="setting-actions">
                <a-switch
                  v-model="shoubtn"
                  @change="handleChange"
                  :checked-children="translate('users.header.title21')"
                  :un-checked-children="translate('users.header.title20')"
                  class="custom-switch"
                />
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane>

      <!-- 单点登录 -->
      <a-tab-pane :tab="translate('users.header.title22')" key="single-sign-on">
        <div class="settings-card">
          <div class="card-content">
            <div class="setting-item">
              <div class="setting-info">
                <div class="setting-icon-wrapper sso-icon">
                  <a-icon type="link" />
                </div>
                <div class="setting-text">
                  <div class="setting-title">{{ translate('users.header.title22') }}</div>
                  <div class="setting-desc">{{ translate('users.header.title30') }}</div>
                </div>
              </div>
              <div class="setting-actions">
                <a-switch
                  v-model="shouSingle"
                  @change="handleChangeSingle"
                  :checked-children="translate('users.header.title24')"
                  :un-checked-children="translate('users.header.title23')"
                  class="custom-switch"
                />
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane>

      <!-- OpenAPI设置 -->
      <!-- <a-tab-pane :tab="translate('users.header.title25')" key="openapi">
        <div class="settings-card">
          <div class="card-content">
            <div class="setting-item openkey-item">
              <div class="setting-info">
                <div class="setting-icon-wrapper api-icon-wrapper">
                  <a-icon type="api" />
                </div>
                <div class="setting-text">
                  <div class="setting-title">{{ translate('users.header.title25') }}</div>
                  <div class="setting-desc">{{ translate('users.header.title41') }}</div>
                </div>
              </div>
              <div class="setting-actions">
                <a-button
                  v-if="isReview === -1"
                  @click="handleOpenapi"
                  type="primary"
                  class="action-btn apply-btn"
                >
                  <a-icon type="plus" />
                  {{ translate('users.header.title40') }}
                </a-button>
                <a-button
                  v-else-if="isReview === 0"
                  disabled
                  class="action-btn disable-btn"
                >
                  <a-icon type="clock-circle" />
                  {{ translate('users.header.title48') }}
                </a-button>
                <a-button
                  v-else-if="isReview === 2"
                  @click="handleOpenapi"
                  type="primary"
                  class="action-btn apply-btn"
                >
                  <a-icon type="reload" />
                  {{ translate('users.header.title47') }}
                </a-button>
              </div>
            </div>
            <div v-if="isReview === 1" class="openkey-section">
              <div class="openkey-row">
                <div class="openkey-label">{{ translate('users.header.title25') }}:</div>
                <div class="openkey-value">{{ openkey }}</div>
                <div class="openkey-actions">
                  <a-button
                    @click="handleOpenkey(showbrowse ? 1 : 2)"
                    type="text"
                    class="action-btn text-btn"
                  >
                    {{ showbrowse ? translate('users.header.title32') : translate('users.header.title31') }}
                  </a-button>
                  <a-button
                    @click="handleResetOpenkey"
                    type="text"
                    class="action-btn danger-btn"
                  >
                    {{ translate('users.header.title42') }}
                  </a-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane> -->
    </a-tabs>

    <!-- 谷歌验证弹窗 -->
    <a-modal
      v-model="visible"
      :title="translate('users.header.title20')"
      :footer="null"
      width="400px"
      class="auth-modal"
      @close="handleCancel"
      @afterClose="handleAfterClose"
    >
      <div class="modal-content">
        <div class="modal-header" v-if="showQrCode">
          <a-icon type="qrcode" class="modal-icon" />
          <span>{{ translate('users.header.title33') }}</span>
        </div>
        <div class="qrcode-section" v-if="showQrCode">
          <div class="qr-code">
            <qrcode-vue :value="imgurl" :size="200" level="L" />
          </div>
        </div>
        <div class="authcode-section">
          <a-form :form="form" layout="vertical">
            <a-form-item :label="translate('users.header.title26')" name="authcode">
              <a-input
                v-model="authcodein"
                :placeholder="translate('users.header.title35')"
                maxlength="6"
                class="custom-input"
              />
            </a-form-item>
            <a-form-item v-if="!showQrCode" :label="translate('users.header.title28')" name="password">
              <a-input-password v-model="password" :placeholder="translate('users.header.title28')" class="custom-input" />
            </a-form-item>
          </a-form>
        </div>
        <div class="modal-actions">
          <a-button @click="handleCancel" class="reset-btn">
            {{ languageState.languageCode === 'zh' ? '取消' : 'Cancel' }}
          </a-button>
          <a-button type="primary" @click="showQrCode ? onConfirm() : onConfirmGoole()" class="submit-btn">
            {{ showQrCode ? translate('users.header.title43') : translate('users.header.title44') }}
          </a-button>
        </div>
      </div>
    </a-modal>

    <!-- 重置OpenKey弹窗 -->
    <a-modal
      v-model="visibleModal"
      :title="translate('users.header.title42')"
      :footer="null"
      width="400px"
      class="auth-modal"
    >
      <div class="modal-content">
        <div class="modal-header warning">
          <a-icon type="exclamation-circle" class="modal-icon warning" />
          <span>{{ translate('users.header.title37') }}</span>
        </div>
        <div class="authcode-section">
          <a-form :form="form" layout="vertical">
            <a-form-item :label="translate('users.header.title38')" name="oldopenkey">
              <a-input
                v-model="oldopenkey"
                :placeholder="translate('users.header.title39')"
                class="custom-input"
              />
            </a-form-item>
          </a-form>
        </div>
        <div class="modal-actions">
          <a-button @click="handleCancel" class="reset-btn">
            {{ languageState.languageCode === 'zh' ? '取消' : 'Cancel' }}
          </a-button>
          <a-button type="primary" @click="handleResetOpenkeyConfirm" class="submit-btn">
            {{ translate('users.header.title45') }}
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode-vue';

export default {
  name: 'UserSettings',
  inject: ['languageState'],
  components: {
    QrcodeVue
  },
  watch: {
    visible(newVal) {
      if (!newVal && this.showQrCode) {
        this.resetButtonState();
      }
    }
  },
  data() {
    return {
      activeKey: 'password',
      submitting: false,
      form: null,
      formData: {
        oldpasswd: '',
        newpasswd: '',
        passwordcheck: ''
      },
      qrCodeUrl: '',
      imageUrl: '',
      visible: false,
      visibleClose: false,
      visibleModal: false,
      imgurl: '',
      authcodein: '',
      password: '',
      shoubtn: false,
      shouSingle: false,
      userdata: {},
      isReview: -1,
      openkey: '*********',
      showbrowse: false,
      oldopenkey: '',
      showQrCode: false
    };
  },
  mounted() {
    this.getGooleAuthInfo();
    this.getUserInfo();
    this.checkApplyOpenkey();
  },
  methods: {
    // 获取谷歌验证信息
    getGooleAuthInfo() {
      this.$request.post('/gooleauth/getGoogleAuth').then((res) => {
        if(res.data.data){
          if(res.data.data.status == 1){
            this.shoubtn = true;
          } else {
            this.shoubtn = false;
          }
        }else{
          this.shoubtn = false;
        }
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
        });
    },
    
    // 获取用户信息
    getUserInfo() {
      this.$request.get('/ums/user/info').then((res) => {
        if (res.data.data) {
          this.userdata = res.data.data;
          this.shouSingle = res.data.data.isSingle === 0 ? false : true;
        }
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {})
    },
    
    // 查询当前用户是否申请了openkey
    checkApplyOpenkey() {
      this.$request.get('/ums/user/checkApplyOpenkey').then((res) => {
        if(res.data.data){
          if(res.data.data.isreview === 0){
            this.isReview = 0;
          } else if(res.data.data.isreview === 1){
            this.isReview = 1;
          } else if(res.data.data.isreview === 2){
            this.isReview = 2;
          } else{
            this.isReview = 3;
          }
        }
      })
    },
    
    // 申请openapi
    handleOpenapi() {
      this.$confirm({
        title: this.translate('users.header.title46'),
        content: this.languageState.languageCode === 'zh' ? '申请openkey后,可以在开放平台调用该接口' : 'After applying for openkey, you can call this interface on the open platform',
        onOk: () => {
          this.$request.post('/ums/user/applyOpenkey', {}).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(this.languageState.languageCode === 'zh' ? '申请成功,请等待审核' : 'Application successful, please wait for review');
              this.checkApplyOpenkey();
            }
          })
        }
      });
    },
    
    // 查看openkey
    handleOpenkey(type) {
      if(type === 2){
          this.$request.get('/ums/user/getOpenkey').then((res) => {
            if(res.data.data){
              this.openkey = res.data.data.key;
              this.showbrowse = true;
            }else{
              this.$message.error(this.languageState.languageCode === 'zh' ? '获取失败' : 'Failed to get');
              this.showbrowse = false;
            }
          })
        }else{
          this.showbrowse = false;
          this.openkey = "*********";
        }
    },
    
    // 重置openkey
    handleResetOpenkey() {
      this.visibleModal = true;
    },
    
    // 重置openkey确认
    handleResetOpenkeyConfirm() {
      if(this.oldopenkey === ""){
        this.$message.error(this.translate('users.header.title39'));
        return;
      }
      this.$request.get('/ums/user/resetOpenkey?oldkey='+this.oldopenkey).then((res) => {
        if(res.data.code === 200){
          this.$message.success(this.languageState.languageCode === 'zh' ? '重置成功' : 'Reset successful');
          this.visibleModal = false;
          this.oldopenkey = "";
          this.openkey = "*********";
          this.showbrowse = false;
        }else{
          this.$message.error(this.languageState.languageCode === 'zh' ? '重置失败' : 'Reset failed');
        }
      })
    },
    
    // 处理菜单选择
    handleMenuSelect({ key }) {
      this.activeKey = key;
    },
    
    // 处理谷歌验证开关
    handleChange(e) {
      this.authcodein = "";
      this.password = "";
      if(e){
        this.getGooleAuthCode();
        this.showQrCode = true;
        this.visible = true;
      }else{
        this.showQrCode = false;
        this.visibleClose = true;
      }
    },
    
    // 获取谷歌验证二维码
    getGooleAuthCode(){
      this.$request.post('/gooleauth/startGoogleAuthenticator').then((res) => {
        this.imgurl = res.data;
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
        });
    },
    
    // 确认谷歌验证
    onConfirm() {
      this.$request.post('/gooleauth/openGoogleAuthenticator',{
        code:this.authcodein
      }).then((res) => {
        if(res.data.data == 1){
          window.localStorage.clear();
          this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        }else{
          this.$message.error('验证失败');
          this.visible = false;
        }
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
        });
    },
    
    // 确认关闭谷歌验证
    onConfirmGoole() {
      this.$request.post('/gooleauth/closeGoogleAuthenticator',{
        code:this.authcodein,
        password:this.password,
      }).then((res) => {
        console.log(res);
        if(res.data.data == 1){
          window.localStorage.clear();
          this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        }else{
          this.$message.error('验证失败');
          this.visibleClose = false;
        }
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
        });
    },
    
    // 取消弹窗
    handleCancel() {
      this.visible = false;
      this.visibleClose = false;
      this.visibleModal = false;
      this.resetButtonState();
    },
    
    // 弹窗关闭后重置状态
    handleAfterClose() {
      this.resetButtonState();
    },
    
    // 重置按钮状态
    resetButtonState() {
      if (this.showQrCode) {
        this.shoubtn = false;
        this.showQrCode = false;
      }
    },
    
    // 更改密码
    onSubmit() {
      this.submitting = true;
      this.$request
        .post('/ums/user/save', this.formData)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('修改成功');
            window.localStorage.clear();
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    
    // 重置表单
    onReset() {
      this.formData.oldpasswd = '';
      this.formData.newpasswd = '';
      this.formData.passwordcheck = '';
    },
    
    // 密码确认验证方法
    rePassword(rule, value, callback) {
      if (!value || this.formData.newpasswd === value) {
        callback();
      } else {
        callback(new Error('两次密码不一致'));
      }
    },
    
    // 单点登录开关
    handleChangeSingle(e) {
      if(e){
        this.$request.post('/ums/updateIsSingle',{
          isSingle:1
        }).then((res) => {
          if(res.data.code == 200){
            window.localStorage.clear();
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          }else{
            this.$message.error('开启失败');
          }
        })
      }else{
        this.$request.post('/ums/updateIsSingle',{
          isSingle:0
        }).then((res) => {
          if(res.data.code == 200){
            window.localStorage.clear();
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          }else{
            this.$message.error('开启失败');
          }
        })
      }
    },
    
    // 国际化翻译
    translate(key) {
      const lang = this.languageState ? this.languageState.languageCode : 'zh';
      const translations = {
        'users.header.title1': lang === 'zh' ? '修改密码' : 'Change Password',
        'users.header.title2': lang === 'zh' ? '旧密码' : 'Old Password',
        'users.header.title3': lang === 'zh' ? '新密码' : 'New Password',
        'users.header.title4': lang === 'zh' ? '确认密码' : 'Confirm Password',
        'users.header.title5': lang === 'zh' ? '重置' : 'Reset',
        'users.header.title6': lang === 'zh' ? '请输入旧密码' : 'Please enter old password',
        'users.header.title7': lang === 'zh' ? '请输入新密码' : 'Please enter new password',
        'users.header.title8': lang === 'zh' ? '请再次输入密码' : 'Please re-enter password',
        'users.header.title19': lang === 'zh' ? '安全设置' : 'Security Settings',
        'users.header.title20': lang === 'zh' ? '开启谷歌验证' : 'Enable Google Verification',
        'users.header.title21': lang === 'zh' ? '关闭谷歌验证' : 'Disable Google Verification',
        'users.header.title22': lang === 'zh' ? '单点登录' : 'Single Sign On',
        'users.header.title23': lang === 'zh' ? '开启单点登录' : 'Enable Single Sign On',
        'users.header.title24': lang === 'zh' ? '关闭单点登录' : 'Disable Single Sign On',
        'users.header.title25': lang === 'zh' ? 'OpenAPI设置' : 'OpenAPI Settings',
        'users.header.title26': lang === 'zh' ? '验证码' : 'Verification Code',
        'users.header.title27': lang === 'zh' ? '关闭谷歌验证' : 'Disable Google Verification',
        'users.header.title28': lang === 'zh' ? '密码' : 'Password',
        'users.header.title29': lang === 'zh' ? '绑定Google Authenticator增强账户安全性' : 'Bind Google Authenticator to enhance account security',
        'users.header.title30': lang === 'zh' ? '开启单点登录功能，实现一次登录多处使用' : 'Enable single sign-on function to achieve one login for multiple uses',
        'users.header.title31': lang === 'zh' ? '显示' : 'Show',
        'users.header.title32': lang === 'zh' ? '隐藏' : 'Hide',
        'users.header.title33': lang === 'zh' ? '扫描二维码绑定Google Authenticator' : 'Scan QR code to bind Google Authenticator',
        'users.header.title34': lang === 'zh' ? '请输入验证码' : 'Please enter verification code',
        'users.header.title35': lang === 'zh' ? '请输入6位验证码' : 'Please enter 6-digit verification code',
        'users.header.title36': lang === 'zh' ? '关闭谷歌验证需要验证身份' : 'Disabling Google verification requires identity verification',
        'users.header.title37': lang === 'zh' ? '请输入原OpenAPI Key进行验证' : 'Please enter original OpenAPI Key for verification',
        'users.header.title38': lang === 'zh' ? '原OpenAPI Key' : 'Original OpenAPI Key',
        'users.header.title39': lang === 'zh' ? '请输入原本的openkey' : 'Please enter original openkey',
        'users.header.title40': lang === 'zh' ? '申请OpenAPI Key' : 'Apply for OpenAPI Key',
        'users.header.title41': lang === 'zh' ? '获取API访问权限，集成第三方应用' : 'Get API access to integrate third-party applications',
        'users.header.title42': lang === 'zh' ? '重置OpenAPI Key' : 'Reset OpenAPI Key',
        'users.header.title43': lang === 'zh' ? '确认绑定' : 'Confirm Binding',
        'users.header.title44': lang === 'zh' ? '确认关闭' : 'Confirm Closure',
        'users.header.title45': lang === 'zh' ? '确认重置' : 'Confirm Reset',
        'users.header.title46': lang === 'zh' ? '申请openkey' : 'Apply for openkey',
        'users.header.title47': lang === 'zh' ? '重新申请' : 'Re-apply',
        'users.header.title48': lang === 'zh' ? '审核中' : 'Under Review'
      };
      return translations[key] || key;
    }
  }
};
</script>

<style scoped lang="less">
// 深色主题变量
@primary-color: #1581c6;
@primary-hover: #1990d5;
@bg-primary: rgba(30, 41, 59, 0.8);
@bg-secondary: rgba(51, 65, 85, 0.8);
@text-primary: #ffffff;
@text-secondary: rgba(255, 255, 255, 0.8);
@text-tertiary: rgba(255, 255, 255, 0.6);
@border-color: rgba(21, 129, 198, 0.2);
@shadow-color: rgba(0, 0, 0, 0.3);

// 深色主题全局样式
.dark-theme {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  color: @text-primary;
  // min-height: 100vh;
}

// 主容器样式
.settings-container {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
}

// 页面头部
.settings-header {
  margin-bottom: 32px;
  text-align: center;
}

.settings-title {
  font-size: 32px;
  font-weight: 700;
  color: @text-primary;
  margin-bottom: 8px;
  background: linear-gradient(135deg, @primary-color 0%, #64b5f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.settings-subtitle {
  font-size: 16px;
  color: @text-tertiary;
  margin: 0;
}

// 标签页样式
.settings-tabs {
  :deep(.ant-tabs) {
    background: transparent;
  }

  :deep(.ant-tabs-nav) {
    margin-bottom: 24px;
  }

  :deep(.ant-tabs-tab) {
    color: @text-tertiary;
    font-size: 16px;
    font-weight: 500;
    padding: 12px 24px;
  }

  :deep(.ant-tabs-tab:hover) {
    color: @primary-color;
  }

  :deep(.ant-tabs-tab-active) {
    color: @primary-color !important;
  }

  :deep(.ant-tabs-ink-bar) {
    background: linear-gradient(135deg, @primary-color 0%, #64b5f6 100%);
    height: 3px;
  }
}

// 卡片样式
.settings-card {
  background: @bg-primary;
  backdrop-filter: blur(10px);
  border: 1px solid @border-color;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px @shadow-color;
  transition: all 0.3s ease;
  color: @text-primary !important;

  &:hover {
    box-shadow: 0 12px 48px @shadow-color;
    transform: translateY(-2px);
    border-color: rgba(21, 129, 198, 0.4);
  }

  :deep(.ant-card-body) {
    padding: 0;
  }
}

.card-content {
  padding: 20px 0;
}

// 设置项样式
.setting-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid rgba(21, 129, 198, 0.1);

  &:last-child {
    border-bottom: none;
  }
}

.setting-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.setting-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 22px;
  
  &.google-icon {
    background: rgba(21, 129, 198, 0.1);
    color: @primary-color;
  }
  
  &.sso-icon {
    background: rgba(76, 175, 80, 0.1);
    color: #4caf50;
  }
  
  &.api-icon-wrapper {
    background: rgba(255, 193, 7, 0.1);
    color: #ffc107;
  }
}

.setting-text {
  flex: 1;
  
  .setting-title {
    font-size: 16px;
    font-weight: 600;
    color: @text-primary;
    margin-bottom: 4px;
  }
  
  .setting-desc {
    font-size: 14px;
    color: @text-tertiary;
  }
}

.setting-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

// 自定义开关样式
.custom-switch {
  :deep(.ant-switch) {
    background-color: rgba(255, 255, 255, 0.2);
    
    &:checked {
      background-color: @primary-color;
    }
  }
}

// 按钮样式
.action-btn {
  height: 36px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  
  &.enable-btn {
    background: linear-gradient(135deg, @primary-color 0%, #1990d5 100%);
    border: none;
    color: white;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(21, 129, 198, 0.3);
    }
  }
  
  &.disable-btn {
    background: @bg-primary;
    border: 1px solid @border-color;
    color: @text-secondary;
    
    &:hover {
      border-color: #f44336;
      color: #f44336;
    }
  }
  
  &.apply-btn {
    background: linear-gradient(135deg, #ffc107 0%, #ffb300 100%);
    border: none;
    color: #000;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
    }
  }
  
  &.text-btn {
    padding: 4px 8px;
    height: auto;
    background: transparent;
    border: none;
    color: @text-secondary;
    
    &:hover {
      background: rgba(21, 129, 198, 0.1);
      color: @primary-color;
    }
  }
  
  &.danger-btn {
    padding: 4px 8px;
    height: auto;
    background: transparent;
    border: none;
    color: #f44336;
    
    &:hover {
      background: rgba(244, 67, 54, 0.1);
    }
  }
}

// 表单样式
.password-form {
  :deep(.ant-form-item) {
    margin-bottom: 20px;
  }

  :deep(.ant-form-item-label) {
    label {
      font-size: 14px;
      font-weight: 500;
      color: @text-secondary;
    }
  }
}

.form-row {
  margin-bottom: 20px;
}

.form-item {
  margin-bottom: 20px;
}

.custom-input {
  border-radius: 8px;
  height: 44px;
  background: rgba(51, 65, 85, 0.8);
  border: 1px solid @border-color;
  color: @text-primary;
  transition: all 0.3s ease;
  
  &:hover,
  &:focus,
  &:active {
    border-color: @primary-color;
    box-shadow: 0 0 0 2px rgba(21, 129, 198, 0.2);
  }

  :deep(.ant-input) {
    background: transparent;
    border: none;
    color: @text-primary;
    
    &::placeholder {
      color: @text-tertiary;
    }
  }
}

// 表单按钮区域
.form-actions {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid @border-color;
  display: flex;
  gap: 16px;
}

.submit-btn {
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, @primary-color 0%, #1990d5 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(21, 129, 198, 0.3);
  transition: all 0.3s ease;
  color: white;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(21, 129, 198, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.reset-btn {
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 28px;
  border-radius: 8px;
  background: @bg-primary;
  border: 1px solid @border-color;
  transition: all 0.3s ease;
  color: @text-secondary;
  
  &:hover {
    border-color: @primary-color;
    color: @primary-color;
    background: rgba(21, 129, 198, 0.1);
  }
}

// OpenAPI Key区域
.openkey-section {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(21, 129, 198, 0.1);
}

.openkey-row {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;
}

.openkey-label {
  font-size: 14px;
  font-weight: 500;
  color: @text-secondary;
  min-width: 120px;
}

.openkey-value {
  font-family: 'Courier New', monospace;
  color: @text-primary;
  background: rgba(51, 65, 85, 0.8);
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
  flex: 1;
  min-width: 200px;
  border: 1px solid @border-color;
}

.openkey-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

// 模态框样式
.auth-modal {
  :deep(.ant-modal) {
    background: rgba(30, 41, 59, 0.95);
    backdrop-filter: blur(10px);
    border: 1px solid @border-color;
    border-radius: 12px;
  }

  :deep(.ant-modal-header) {
    padding: 20px 24px;
    border-bottom: 1px solid @border-color;
    background: @bg-primary;
    border-radius: 12px 12px 0 0;
    
    .ant-modal-title {
      font-size: 16px;
      font-weight: 600;
      color: @text-primary;
    }
  }
  
  :deep(.ant-modal-body) {
    padding: 24px;
    background: @bg-primary;
    color: @text-primary;
  }
  
  :deep(.ant-modal-footer) {
    padding: 16px 24px;
    border-top: 1px solid @border-color;
    background: @bg-primary;
    border-radius: 0 0 12px 12px;
  }
}

.modal-content {
  background: transparent !important;
  .modal-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    padding: 16px 20px;
    // background: linear-gradient(135deg, rgba(21, 129, 198, 0.15) 0%, rgba(99, 102, 241, 0.1) 100%);
    border-radius: 10px;
    border: 1px solid rgba(21, 129, 198, 0.3);
    
    .modal-icon {
      font-size: 24px;
      color: @primary-color;
      padding: 10px;
      background: rgba(21, 129, 198, 0.2);
      border-radius: 8px;
      
      &.warning {
        color: #ffc107;
        background: rgba(255, 193, 7, 0.2);
      }
    }
    
    span {
      font-size: 16px;
      font-weight: 600;
      color: @text-primary;
    }
  }
  
  .qrcode-section {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    
    .qr-code {
      padding: 20px;
      background: rgba(30, 41, 59, 0.8);
      border-radius: 16px;
      border: 2px solid @border-color;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
      
      :deep(.qrcode-vue) {
        border-radius: 8px;
        overflow: hidden;
      }
      
      :deep(img) {
        display: block;
        border-radius: 8px;
      }
    }
  }
  
  .authcode-section {
    :deep(.ant-form-item) {
      margin-bottom: 16px;
    }
    
    :deep(.ant-form-item-label) {
      padding-bottom: 8px;
      
      label {
        font-weight: 600;
        color: @text-secondary;
        font-size: 14px;
      }
    }
    
    :deep(.ant-input) {
      background: rgba(30, 41, 59, 0.8);
      border: 2px solid @border-color;
      border-radius: 10px;
      color: @text-primary;
      font-size: 18px;
      letter-spacing: 8px;
      text-align: center;
      padding: 12px 16px;
      height: auto;
      transition: all 0.3s ease;
      
      &:hover, &:focus {
        border-color: @primary-color;
        box-shadow: 0 0 0 3px rgba(21, 129, 198, 0.2);
      }
      
      &::placeholder {
        letter-spacing: 2px;
        color: @text-tertiary;
      }
    }
  }
  
  .modal-actions {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 28px;
    
    .reset-btn {
      height: 44px;
      padding: 0 32px;
      border-radius: 10px;
      font-weight: 600;
      font-size: 14px;
      background: transparent;
      border: 2px solid @border-color;
      color: @text-secondary;
      transition: all 0.3s ease;
      
      &:hover {
        border-color: @text-secondary;
        color: @text-primary;
        background: rgba(255, 255, 255, 0.05);
      }
    }
    
    .submit-btn {
      height: 44px;
      padding: 0 32px;
      border-radius: 10px;
      font-weight: 600;
      font-size: 14px;
      background: linear-gradient(135deg, @primary-color 0%, #0ea5e9 100%);
      border: none;
      color: #fff;
      transition: all 0.3s ease;
      
      &:hover {
        background: linear-gradient(135deg, #0ea5e9 0%, @primary-color 100%);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(21, 129, 198, 0.4);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .settings-container {
    padding: 16px;
  }
  
  .settings-title {
    font-size: 24px;
  }
  
  .settings-subtitle {
    font-size: 14px;
  }
  
  .settings-card {
    padding: 16px;
  }
  
  .setting-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .setting-actions {
    width: 100%;
    justify-content: flex-start;
  }
  
  .openkey-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .openkey-value {
    width: 100%;
  }
  
  .openkey-actions {
    width: 100%;
    justify-content: flex-start;
  }
  
  .form-actions {
    flex-direction: column;
    gap: 12px;
    
    button {
      width: 100%;
    }
  }
  
  .settings-tabs {
    :deep(.ant-tabs-tab) {
      font-size: 14px;
      padding: 8px 16px;
    }
  }
}

:deep(.ant-modal-content) {
  background: transparent !important;
}
</style>
